export const APISettings = {
    headers: new Headers({
        'Accept': 'application/json'
    }),
    baseURL: 'https://abonnements-api.armorlux.com/api',
}